import { useEffect, useState } from "react";
import { ParentGetStudentPoints } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import ParentFmt from "./ParentFmt";
import { useAuth } from "context/AuthContext";

const ParentPointsTab = ({studentId}) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {

        ParentGetStudentPoints(userInfo?.token, Number(studentId)).then(r => setData(r)).catch(() => setData({ points: 0, history: [] }));

    }, []);



    if (!data) return <ParentLoader />;



    const { points, history } = data;

    // Calculate level based on points (example logic: 100 points = 1 level)

    const level = Math.floor(points / 100) + 1;

    const progress = points % 100;



    return (

        <div className="space-y-6">

            {/* Balance Card */}

            <div className="bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-3xl p-8 text-white shadow-xl relative overflow-hidden group">

                <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl -mr-20 -mt-20 group-hover:opacity-20 transition-opacity"></div>

                <div className="absolute bottom-0 left-0 w-48 h-48 bg-purple-900 opacity-20 rounded-full blur-2xl -ml-10 -mb-10 group-hover:opacity-30 transition-opacity"></div>



                <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">

                    <div className="text-center md:text-right">

                        <h3 className="text-xl font-bold text-purple-100 mb-2 drop-shadow-sm">إجمالي النقاط والمكافآت</h3>

                        <div className="text-6xl md:text-7xl font-black drop-shadow-lg flex items-center gap-4 justify-center md:justify-start">

                            <span>{points}</span>

                            <span className="text-5xl animate-bounce">🏆</span>

                        </div>

                    </div>



                    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 w-full md:w-72 shadow-inner">

                        <div className="flex justify-between items-center mb-3">

                            <span className="font-bold text-lg">المستوى {level}</span>

                            <span className="text-sm text-purple-100 font-medium">{progress} // 100 نقطة</span>

                        </div>

                        <div className="w-full bg-black/20 rounded-full h-4 overflow-hidden shadow-inner">

                            <div className="bg-gradient-to-r from-yellow-300 to-yellow-500 h-4 rounded-full relative" style={{ width: `${progress}%` }}>

                                <div className="absolute inset-0 bg-white/20 w-full h-full animate-[shimmer_2s_infinite]"></div>

                            </div>

                        </div>

                        <p className="text-xs text-purple-200 mt-3 text-center">استمر في التميز للوصول للمستوى التالي!</p>

                    </div>

                </div>

            </div>



            {/* History Table */}

            <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm">

                <div className="p-6 border-b border-gray-200 dark:border-white/10 flex items-center gap-3">

                    <span className="text-2xl">📜</span>

                    <h3 className="text-xl font-bold text-watomsBlue dark:text-white">سجل العمليات</h3>

                </div>

                {history.length === 0 ? <ParentEmpty msg="لا يوجد سجل للنقاط حتى الآن" /> : (

                    <div className="overflow-x-auto">

                        <table className="w-full text-base text-right">

                            <thead className="bg-gray-100/80 dark:bg-white/10 text-gray-900 dark:text-gray-100 font-bold border-b border-gray-300 dark:border-white/20">

                                <tr>

                                    <th className="px-6 py-4">السبب / نوع المكافأة</th>

                                    <th className="px-6 py-4 text-center">النقاط</th>

                                    <th className="px-6 py-4">النوع</th>

                                    <th className="px-6 py-4">التاريخ</th>

                                </tr>

                            </thead>

                            <tbody className="divide-y divide-gray-200 dark:divide-white/5">

                                {history.map(item => {

                                    const p = item.point;

                                    const isReward = p?.points > 0 || String(p?.type).includes('reward');

                                    return (

                                        <tr key={item.id} className="hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors">

                                            <td className="px-6 py-4 text-gray-900 dark:text-gray-100 font-bold text-base">

                                                {p?.name || '—'}

                                            </td>

                                            <td className="px-6 py-4 text-center">

                                                <span className={`inline-block w-16 text-center px-3 py-1.5 rounded-full text-base font-black shadow-sm ${isReward ? 'bg-emerald-100 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-300' : 'bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-300'}`}>

                                                    {isReward ? '+' : ''}{p?.points || 0}

                                                </span>

                                            </td>

                                            <td className="px-6 py-4">

                                                <span className={`text-sm font-bold ${isReward ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>

                                                    {isReward ? 'مكافأة 🌟' : 'خصم ⚠️'}

                                                </span>

                                            </td>

                                            <td className="px-6 py-4 text-gray-700 dark:text-gray-300 whitespace-nowrap font-medium">

                                                {ParentFmt(item.createdAt)}

                                            </td>

                                        </tr>

                                    );

                                })}

                            </tbody>

                        </table>

                    </div>

                )}

            </div>



            <style>{`

                @keyframes shimmer {

                    0% { transform: translateX(-100%); }

                    100% { transform: translateX(100%); }

                }

            `}</style>

        </div>

    );
}

export default ParentPointsTab;